let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1kxr8")).then(() => parcelRequire('BuMXv'));